<template>
    <div>
        <el-row>
            <el-col>
                <el-form :inline="true" :model="searchForm" :ref="searchForm" style="margin: 0">
                    <el-form-item label="客户：">
                        <el-select size="medium" v-model="searchForm.CUSTOMER_ID" filterable placeholder="请选择客户" clearable>
                            <el-option v-for="item in customerList" :key="item.ID" :label="item.AB_NAME" :value="item.ID">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="供应商：">
                        <el-select filterable v-model="searchForm.SUPPLIER_ID" placeholder="请选择供应商" clearable>
                            <el-option v-for="item in supplier" :key="item.SUPPLIER_ID" :label="item.NAME"
                                :value="item.SUPPLIER_ID">
                                <span style="float: left">{{ item.NAME }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-button size="medium" type="primary" @click="filtrate()">筛选</el-button>
                    <el-button size="medium" @click="exportDialogVisible = true">导出建议售价</el-button>
                </el-form>
            </el-col>
        </el-row>
        <el-row style="margin-bottom:20px">
            <el-button size="medium" @click="addDialogVisible = true">新增加价</el-button>
        </el-row>
        <el-row>
            <el-col>
                <el-table :data="tableData" border stripe>
                    <el-table-column type="index" label="序号" width="50"></el-table-column>
                    <el-table-column prop="CUSTOMER_NAME" label="客户"></el-table-column>
                    <el-table-column prop="SUPPLIER_NAME" label="供应商"></el-table-column>
                    <el-table-column prop="SCHEME_NAME" label="加点级别"></el-table-column>
                    <el-table-column fixed="right" label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="updateAddPrice(scope.row)">修改加点</el-button>
                            <el-button type="text" size="small" @click="setSingleItem(scope.row)">配置单品</el-button>
                            <el-button type="text" size="small" @click="unchainRelation(scope.row)">解除关系</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-col>
        </el-row>
        <!-- 新增加价模态框 -->
        <el-dialog title="新增加价关系" center :visible.sync="addDialogVisible" width="400px">
            <el-form :model="addForm" ref="addForm" size="small" :rules="addRules" label-position="right"
                label-width="100px">
                <el-form-item label="客户：" prop="CUSTOMER_ID">
                    <el-select size="medium" v-model="addForm.CUSTOMER_ID" filterable placeholder="请选择客户" clearable>
                        <el-option v-for="item in customerList" :key="item.ID" :label="item.AB_NAME" :value="item.ID">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="供应商：" prop="SUPPLIER_ID">
                    <el-select size="medium" filterable v-model="addForm.SUPPLIER_ID" placeholder="请选择" clearable>
                        <el-option v-for="item in supplier" :key="item.SUPPLIER_ID" :label="item.NAME"
                            :value="item.SUPPLIER_ID"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="加价规则：" prop="SCHEME_ID">
                    <el-select size="medium" filterable v-model="addForm.SCHEME_ID" placeholder="请选择" clearable>
                        <el-option v-for="item in addPriceRules" :key="item.SCHEME_ID" :label="item.SCHEME_NAME"
                            :value="item.SCHEME_ID"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="addDialogVisible = false">取 消</el-button>
                <el-button size="small" @click="addPriceRelation()">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 修改加价模态框 -->
        <el-dialog title="修改加价关系" center :visible.sync="updateDialogVisible" width="400px">
            <el-form :model="updateForm" ref="updateForm" size="small" :rules="updateRules" label-position="right"
                label-width="100px">
                <el-form-item label="加价规则：" prop="SCHEME_ID">
                    <el-select size="medium" filterable v-model="updateForm.SCHEME_ID" placeholder="请选择" clearable>
                        <el-option v-for="item in addPriceRules" :key="item.SCHEME_ID" :label="item.SCHEME_NAME"
                            :value="item.SCHEME_ID"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="updateDialogVisible = false">取 消</el-button>
                <el-button size="small" @click="updatePriceRelation()">确 定</el-button>
            </div>
        </el-dialog>
        <!-- 导出模态框 -->
        <el-dialog title="导出建议售价" center :visible.sync="exportDialogVisible" width="400px">
            <el-form :model="exportForm" ref="exportForm" size="small" label-position="right" label-width="100px">
                <!-- <el-form-item label="产品编码：">
                    <el-input size="medium" v-model="exportForm.productCode"
                        onkeyup="this.value=this.value.replace(/^\s+|\s+$/g,'')"></el-input>
                </el-form-item>
                <el-form-item label="商品名称：">
                    <el-input size="medium" v-model="exportForm.productName"
                        onkeyup="this.value=this.value.replace(/^\s+|\s+$/g,'')"></el-input>
                </el-form-item> -->
                <el-form-item label="客户：" prop="CUSTOMER_ID">
                    <el-select size="medium" v-model="exportForm.CUSTOMER_ID" filterable placeholder="请选择客户" clearable>
                        <el-option v-for="item in customerList" :key="item.ID" :label="item.AB_NAME" :value="item.ID">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="exportDialogVisible = false">取 消</el-button>
                <el-button size="small" @click="exportAdvicePrice()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import { haveGYSFun } from 'api/shopOrderManage';
import { getEnteyCusFun } from 'api/sellOrder';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      searchForm: {},
      tableData: [],
      supplier: [],
      customerList: [],
      addPriceRules: [],
      addDialogVisible: false,
      updateDialogVisible: false,
      exportDialogVisible: false,
      addForm: {},
      updateForm: {},
      exportForm: {},
      addRules: {
        CUSTOMER_ID: [
          { required: true, message: '请选择客户', trigger: 'blur' },
        ],
        SUPPLIER_ID: [
          { required: true, message: '请选择供应商', trigger: 'blur' },
        ],
        SCHEME_ID: [
          { required: true, message: '请选择加价规则', trigger: 'blur' },
        ],
      },
      updateRules: {
        SCHEME_ID: [
          { required: true, message: '请选择加价规则', trigger: 'blur' },
        ],
      },
    };
  },
  created() {
    // 获取供应商列表
    this.querySupplier();
    // 获取客户列表
    this.queryCustomerList();
    this.queryData();
    this.queryAddPriceRule();
  },
  methods: {
    exportAdvicePrice() {
      this.exportDialogVisible = false;
      const params = {
        SERVICE_ID: '10013',
        OTYPE: 31,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.exportForm.CUSTOMER_ID) {
        params.CUSTOMER_ID = this.exportForm.CUSTOMER_ID;
      }
      // if (this.exportForm.productCode) {
      //     params.PRODUCT_CODE = this.exportForm.productCode;
      // }
      // if (this.exportForm.productName) {
      //     params.PRODUCT_NAME = this.exportForm.productName;
      // }
      http
        .post(params)
        .then((result) => {
          if (result.length === 0) {
            this.$message.show({ text: '暂无数据', type: 'warning' });
          } else if (result[0].FILE_PATH !== '') {
            window.location.href = this.$util.getURLLocalHost(result[0].FILE_PATH);
          } else {
            this.$message.show({ text: '返回路径异常', type: 'error' });
          }
        })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    setSingleItem(row) {
      // console.log('row',row)
      this.$router.push({
        name: 'newProjectProduct',
        params: {
          RELATION_ID: row.RELATION_ID,
          row,
        },
      });
    },
    unchainRelation(row) {
      this.$confirm('您确认要解除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          SERVICE_ID: '15072',
          OTYPE: 4,
          RELATION_ID: row.RELATION_ID,
        };
        http
          .post(params)
          .then((result) => {
            this.queryData();
            this.$message.show({ text: '解除成功！', type: 'success' });
          })
          .catch((error) => {
            this.$message.show({ text: error, type: 'error' });
          });
      });
    },
    updateAddPrice(row) {
      this.updateForm = row;
      this.updateDialogVisible = true;
    },
    queryAddPriceRule() {
      const params = {
        SERVICE_ID: '10023',
        OTYPE: 7,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGE_INDEX: 0,
        PAGE_SIZE: 10000000,
      };
      http.post(params).then((result) => {
        this.addPriceRules = result.length > 0 ? result[0].SCHEME_LIST : [];
      })
        .catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    addPriceRelation() {
      if (!this.addForm.CUSTOMER_ID || !this.addForm.SCHEME_ID || !this.addForm.SUPPLIER_ID) {
        this.$message.show({ text: '请填写客户、供应商、加价规则', type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '15072',
        OTYPE: 1,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        SUPPLIER_ID: this.addForm.SUPPLIER_ID,
        CUSTOMER_ID: this.addForm.CUSTOMER_ID,
        SCHEME_ID: this.addForm.SCHEME_ID,
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '添加成功', type: 'success' });
        this.addDialogVisible = false;
        this.queryData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    updatePriceRelation() {
      if (!this.updateForm.SCHEME_ID) {
        this.$message.show({ text: '请填写客户、供应商、加价规则', type: 'warning' });
        return;
      }
      const params = {
        SERVICE_ID: '15072',
        OTYPE: 3,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        RELATION_ID: this.updateForm.RELATION_ID,
        SCHEME_ID: this.updateForm.SCHEME_ID,
      };
      http.post(params).then((res) => {
        this.$message.show({ text: '修改成功', type: 'success' });
        this.updateDialogVisible = false;
        this.queryData();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 获取供应商列表
    querySupplier() {
      const params = {};
      if (this.searchForm.SUPPLIER) {
        params.SUPPLIER_NAME = this.searchForm.SUPPLIER;
      }
      haveGYSFun().then((result) => {
        this.supplier = result.length > 0 ? this.$util.listRemoveDuplicates(result[0].list) : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 获取客户列表
    queryCustomerList() {
      getEnteyCusFun({})
        .then((res) => {
          this.customerList = res.length > 0 ? this.$util.listRemoveDuplicates(res) : [];
        }).catch((err) => {
          this.$message.show({ text: err, type: 'error' });
        });
    },
    filtrate() {
      // this.currentPage = 1;
      this.queryData();
    },
    queryData() {
      const params = {
        SERVICE_ID: '15072',
        OTYPE: 2,
        PAGE_SIZE: 100000000,
        PAGE_INDEX: 0,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.searchForm.CUSTOMER_ID) {
        params.CUSTOMER_ID = this.searchForm.CUSTOMER_ID;
      }
      if (this.searchForm.SUPPLIER_ID) {
        params.SUPPLIER_ID = this.searchForm.SUPPLIER_ID;
      }
      http.post(params).then((res) => {
        if (res.length === 0) {
          this.$message.show({ text: '暂无数据', type: 'warning' });
          this.tableData = [];
          this.total_count = 0;
        } else {
          this.tableData = res[0].RELATION_LIST;
          this.total_count = res[0].TOTAL_COUNT;
          // this.$store.dispatch('SET_PURCHASE_PRICE_INQUIRY_CONDITION', {
          //     CONDITION: this.searchForm,
          //     CURRENT_PAGE: this.currentPage,
          // });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/priceManagement/priceIncreaseRelationshipManagement.vue